<template>
  <div>
    <campaign-modal
        v-if="userId !== null"
        :userId="userId"
    />
    <div class="d-flex align-items-center">
      <h3 class="title-content">Veículos Ativos</h3>
    </div>
    <div class="active-vehicles">
      <active-vehicles/>
    </div>
  </div>
</template>

<script>
import ActiveVehicles from '@/components/ActiveVehicles.vue'
import CampaignModal from '@/components/CampaignModal.vue'

export default {
  components: {
    ActiveVehicles,
    CampaignModal
  },
  computed: {
    userId() {
      const user = JSON.parse(localStorage.getItem('user'))
      return user && user.id ? user.id : null
    }
  }
}
</script>

<style scoped>
.active-vehicles {
  margin-bottom: 20px;
}
</style>
